import { render } from "./ITEM_DELETED.vue?vue&type=template&id=021c9ee5&ts=true"
import script from "./ITEM_DELETED.vue?vue&type=script&lang=ts"
export * from "./ITEM_DELETED.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__